export function getSelectedVariant(
  size,
  color,
  opening,
  payment,
  amount,
  length,
  variants
) {
  if (variants.length === 1) {
    return variants[0];
  } else {
    const arr = [color?.name || "", size, opening, payment, amount, length];
    const variant = arr.filter((val) => val).join(" / ");
    return variants.find((v) => v.title === variant);
  }
}
export function getSelectedVariant2(color, selectedVariants, variants) {
  if (variants.length === 1) {
    return variants[0];
  }

  const filterVariants = variants.filter((val) =>
    val.selectedOptions.every((option) => {
      switch (option.name) {
        case "Size":
          return option.value === selectedVariants.selectedSize;
        case "Color":
          return !color || option.value === color.name;
        case "Colour":
          return !color || option.value === color.name;
        case "Opening":
          return option.value === selectedVariants.selectedOpening;
        case "Payment Options":
          return option.value === selectedVariants.selectedPaymentMethod;
        case "Amount":
          return option.value === selectedVariants.selectedAmount;
        case "Length":
          return option.value === selectedVariants.selectedLength;
        case "Fit":
          return option.value === selectedVariants.selectedFit;
        case "Strength":
          return option.value === selectedVariants.selectedStrength;
        case "Shipping Country":
          return option.value === selectedVariants.selectedCountry;
        case "Style":
          return option.value === selectedVariants.selectedStyle;
        default:
          return true;
      }
    })
  );

  return filterVariants[0];
}
